import { Injectable } from '@angular/core';
import { User, UserTier } from '../models/User';
import { StorageService } from './storage.service';

export interface PremiumOfferEligibilityOptions {
  includeTeachers?: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class PremiumOfferService {
  constructor(private storageService: StorageService) {}

  canSeePremiumOffers(user: User | null | undefined, options: PremiumOfferEligibilityOptions = {}): boolean {
    if (!user || user.tier !== UserTier.free) {
      return false;
    }

    return user.is_parent || this.storageService.isAnonymous() || (options.includeTeachers === true && user.is_teacher);
  }
}
